import { GetObjectsQueryDto, ObjectEntity, PageDto } from '@ekt-group/general-purpose-api-interfaces';
import { queryOptions, useQuery } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { QueryConfig } from '@/lib/react-query';

export const getObjects = async (params: GetObjectsQueryDto) => {
  const { data } = await httpService.get<ObjectEntity[] | PageDto<ObjectEntity>>('/objects', {
    params,
  });
  return data;
};

export const getObjectsQueryOptions = (params: GetObjectsQueryDto) => {
  return queryOptions({
    queryKey: ['objects', params],
    queryFn: () => getObjects(params),
  });
};

type UseObjectsOptions = {
  params: GetObjectsQueryDto;
  queryConfig?: QueryConfig<typeof getObjectsQueryOptions>;
};

export const useGetObjects = <T>({ params, queryConfig }: UseObjectsOptions) => {
  return useQuery({
    ...getObjectsQueryOptions(params),
    ...queryConfig,
  });
};
